<!-- 作业登记 -->
<template>
	<div>
		<div class="index">
			<div class="title">
				<div class="span1">
					<span>作业登记</span>
				</div>
				<el-button type="primary" size="small" @click="toAdd()" class="registerHw">
					<img src="./img/task-add-icon.svg" alt="" />
					<p>登记作业</p>
				</el-button>
			</div>

			<div v-loading="loading">
				<el-form :inline="true" :model="queryParams" label-width="45px">
					<el-form-item label="班级:">
						<el-select v-model="queryParams.classId" clearable placeholder="请选择" class="label">
							<el-option
								v-for="item in classList"
								:key="item.classId"
								:label="item.className"
								:value="item.classId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="学科:">
						<el-select v-model="queryParams.subjectId" clearable placeholder="请选择" class="label">
							<el-option
								v-for="item in SubjectList"
								:key="item.subjectId"
								:label="item.subjectName"
								:value="item.subjectId"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="作业日期:" label-width="74px">
						<el-date-picker
							v-model="queryParams.date"
							type="date"
							format="yyyy-MM-dd"
							placeholder="请选择"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label="备案状态:" label-width="74px">
						<el-select v-model="queryParams.stateId" clearable placeholder="请选择" class="label">
							<el-option
								v-for="item in statusList"
								:key="item.stateId"
								:label="item.label"
								:value="item.stateId"
							>
							</el-option>
						</el-select>
					</el-form-item>

					<el-button type="primary" size="small" @click="searchFun()" class="findBtn"
						>查询</el-button
					>
				</el-form>

				<!-- 校内教师 -->
				<div v-if="tableData" class="table" style="width: 100%">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column prop="className" label="发布班级" align="center" width="110">
						</el-table-column>
						<el-table-column prop="homeworkDate" label="作业日期" align="center" width="114">
						</el-table-column>
						<el-table-column prop="subjectName" label="学科" align="center" width="79">
						</el-table-column>
						<el-table-column prop="content" label="作业内容" align="center" width="121">
							<template slot-scope="scope">
								<div class="hwContent">
									<div v-if="scope.row.whetherResource"><img src="./img/hw-link.svg" /></div>
									<div>
										<el-popover
											placement="bottom"
											width="150"
											:content="scope.row.content"
											popper-class="popper-panel-more-allapp"
											trigger="hover"
											:open-delay="300"
										>
											<span slot="reference" class="show-hover ellipsis-m">
												{{ scope.row.content }}</span
											>
										</el-popover>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="estimateDuration"
							label="预计完成时长"
							align="center"
							width="114"
						>
						</el-table-column>
						<el-table-column prop="createTime" label="登记时间" align="center" width="110 ">
						</el-table-column>
						<el-table-column prop="status" label="备案状态" align="center" width="114">
							<template slot-scope="scope">
								<p
									:class="{ waitPreview: scope.row.status === '0' }"
									v-if="scope.row.status === '0'"
								>
									待审核
								</p>
								<p :class="{ passed: scope.row.status === '11' }" v-if="scope.row.status === '11'">
									已通过
								</p>
								<p
									:class="{ inPreview: scope.row.status === '10' }"
									v-if="scope.row.status === '10'"
								>
									审核中
								</p>
								<p :class="{ rejected: scope.row.status === '2' }" v-if="scope.row.status === '2'">
									已驳回
								</p>
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作" align="center">
							<template slot-scope="scope">
								<el-button type="text" @click="toDetail(scope)">查看</el-button>
								<el-button
									type="text"
									@click="toUpdate(scope)"
									v-if="scope.row.status === '2' || scope.row.status === '0'"
									>修改</el-button
								>
								<el-button type="text" @click="toDelete(scope)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- 分页组件 -->
					<div class="pagination">
						<el-pagination
							background
							:current-page="pageNum"
							:page-sizes="[10, 20, 50, 100]"
							:page-size="pageSize"
							:total="totalPage"
							layout="total,prev, pager, next,jumper,sizes"
							@size-change="sizeChangeHandle"
							@current-change="currentChangeHandle"
						></el-pagination>
					</div>
				</div>

				<!-- 未登记作业 -->
				<div v-else class="no-register">
					<img src="./img/no-register.png" />
					<p>您暂未登记作业，<span @click="toAdd()">去登记</span></p>
				</div>
			</div>
		</div>
		<!-- 删除作业弹框 -->
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			custom-class="delDialog"
			:append-to-body="true"
			:before-close="handleClose"
		>
			<span>确定删除吗？删除后，该登记作业将无法恢复！</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="sureDel">删除</el-button>
			</span>
		</el-dialog>
		<!-- 修改作业弹框 -->
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible2"
			custom-class="delDialog"
			:append-to-body="true"
			:before-close="handleClose2"
		>
			<span>确定修改吗？修改之后，登记的作业将重新开始审核。</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2 = false">取消</el-button>
				<el-button type="primary" @click="sureUpdate">修改</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	import { getHwRegisterList, deleteHwRegister } from "@/api/school/index.js";
	import { getClassList } from "@/api/school/schoolChildList.js";
	import dayjs from "dayjs";
	import reqTip from "@/utils/requestTip";
	import localForage from "localforage";

	export default {
		name: "RegisterList",
		data() {
			return {
				dialogVisible: false,
				dialogVisible2: false,
				toRequest: false, //登记作业时请求当前时间到之后的数据
				homeworkId: "",
				loading: true,
				tableData: [],
				classList: [],
				subjectList: [],
				statusList: [
					{ stateId: "0", label: "待审核" },
					{ stateId: "11", label: "已通过" },
					{ stateId: "2", label: "已驳回" },
				],
				pageNum: 1,
				pageSize: 10,
				totalPage: 0,
				queryParams: {
					classId: "",
					subjectId: "",
					date: "",
					stateId: "",
				},
				school_info: JSON.parse(sessionStorage.getItem("classList")),
				semesterArr: JSON.parse(sessionStorage.getItem("semesterList")),
			};
		},
		computed: {},
		watch: {},
		created() {
			console.log(99);
			this.fetchClassList();
		},
		activated() {
			this.toRequest = false;
			this.getTableData();
		},
		methods: {
			// 获取作业登记列表
			async getTableData() {
				this.loading = true;
				let ss = sessionStorage;
				let startDate = this.toRequest
					? dayjs(Date.now()).format("YYYY-MM-DD")
					: (this.queryParams.date && dayjs(this.queryParams.date).format("YYYY-MM-DD")) || "";
				let endDate = this.toRequest
					? ""
					: (this.queryParams.date && dayjs(this.queryParams.date).format("YYYY-MM-DD")) || "";
				let pageNum = this.toRequest ? 1 : this.pageNum;
				let pageSize = this.toRequest ? 100 : this.pageSize;
				let classId = this.toRequest ? "" : this.queryParams.classId;
				let subjectId = this.toRequest ? "" : this.queryParams.subjectId;
				let state = this.toRequest ? "" : this.queryParams.stateId;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					pageNum,
					pageSize,
					classId,
					subjectId,
					startDate,
					endDate,
					state,
				};
				console.log("获取作业登记列表params--", params);
				const res = await getHwRegisterList(params);
				console.log("作业登记列表--", res);
				this.loading = false;
				if (!res) return;
				res.list?.forEach((item) => {
					item.homeworkDate = dayjs(item.homeworkDate).format("YYYY-MM-DD");
					item.createTime = dayjs(item.createTime).format("YYYY-MM-DD HH:mm");
					item.estimateDuration = item.estimateDuration + "分钟";
				});
				this.tableData = res.list;
				localForage.setItem("tableData", this.tableData);
				this.totalPage = res.total;
			},
			// 获取班级列表
			async fetchClassList() {
				let ss = sessionStorage;
				let params = {
					org_id: ss.orgId,
					org_type: "7",
				};
				const res = await getClassList(params);
				console.log("获取班级列表--", res);
				if (!res) return;
				this.classList = res.map((item) => {
					return { classId: item.org_id, className: item.org_name };
				});
				localForage.setItem("classList", this.classList);
			},

			//修改作业
			toUpdate(scope) {
				this.dialogVisible2 = true;
				this.homeworkId = scope.row.homeworkId;
			},
			//确认修改作业
			sureUpdate() {
				this.$router.push({
					path: "/task/register/add",
					query: { id: this.homeworkId, flag: "modify" },
				});
				this.dialogVisible2 = false;
			},
			//确认删除作业
			async sureDel() {
				let ss = sessionStorage;
				let params = {
					loginPlatformCode: ss.loginPlatformCode,
					platformCode: ss.platformCode,
					usessionid: ss.usessionid,
					homeworkId: this.homeworkId,
				};
				const res = await deleteHwRegister(params);
				console.log("删除作业--", res);
				if (!res) return;
				reqTip.showSuccess("删除成功");
				this.dialogVisible = false;
				this.getTableData();
			},
			// 删除作业
			async toDelete(scope) {
				this.dialogVisible = true;
				this.homeworkId = scope.row.homeworkId;
			},
			// 查看作业详情
			toDetail(scope) {
				console.log("详情scope--33", { ...scope.row });
				scope.row.toModify = true;
				this.$router.push({ path: "/task/register/registerDetail", query: scope.row });
			},
			//新增后刷新作业登记列表
			refreshTableData() {
				this.getTableData();
			},

			searchFun() {
				this.pageNum = 1;
				this.getTableData();
			},
			sizeChangeHandle(val) {
				this.pageSize = val;
				this.getTableData();
			},
			currentChangeHandle(val) {
				this.pageNum = val;
				this.getTableData();
			},
			// 登记作业
			toAdd(val) {
				this.toRequest = true;
				this.getTableData();
				this.$router.push({
					path: "/task/register/add",
					query: { flag: "add", tableData: this.tableData },
				});
			},
			// 关闭删除弹框
			handleClose() {
				this.dialogVisible = false;
			},
			//关闭修改弹框
			handleClose2() {
				this.dialogVisible2 = false;
			},
		},
		mounted() {},
	};
</script>
<style lang="less" scoped>
	.index {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.title {
			height: 68px;
			line-height: 80px;
			border-bottom: 1px solid #eaeaea;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			.span1 {
				font-family: "PingFang SC Bold";
				font-weight: 500;
				font-size: 20px;
				text-align: left;
				color: #333;
			}
			::v-deep .el-button span {
				display: flex;
				// align-items: center;
				justify-content: space-around;

				p {
					margin-left: 10px;
					margin-top: 4px;
					font-size: 16px;
				}
				img {
					margin-top: 2px;
					margin-bottom: 3px;
				}
			}
			.registerHw {
				display: flex;
				align-items: center;
				justify-content: space-around;
				margin-top: 25px;
				width: 118px;
				height: 30px;
				border-radius: 4px;
				background: #4991e1;
			}
		}
		.findBtn {
			float: right;
			width: 80px;
			height: 32px;
			border-radius: 3px;
			background: #4991e1;
			font-size: 14px;
			margin-top: 5px;
		}
		.hwContent {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			.show-hover {
				cursor: pointer;
			}
			> div:first-child img {
				width: 18px;
				height: 18px;
				margin-top: 6px;
				margin-right: 5px;
			}
			> div:last-child {
				text-align: left;
			}
		}
		.no-register {
			text-align: center;
			img {
				margin: 128px 0 40px;
				width: 228px;
				height: 120px;
			}
			p {
				color: #333;
				span {
					color: #65a1e5;
					cursor: pointer;
				}
			}
		}
		::v-deep .el-form-item__label {
			color: #333;
		}
		::v-deep .el-form .el-input__inner {
			width: 120px;
			height: 32px;
			border-radius: 3px;
			background: #fff;
			border: 1px solid #ddd;
		}

		::v-deep .el-table__header tr th {
			background: #f7f7f7;
			box-shadow: 0px 1px 0px #eaeaea;
		}
		::v-deep .el-table {
			color: #333;
		}

		::v-deep .el-date-editor .el-range-separator {
			line-height: 22px;
		}
		::v-deep .el-table thead th.el-table__cell {
			padding: 15 0.5px 0;
			font-weight: normal;
			font-size: 14px;
			color: #7a8da2;
			background: #fafafa;
		}
		::v-deep .el-table tbody td.el-table__cell {
			padding: 18.5px 0;
		}

		.pagination {
			text-align: center;
			margin-top: 30px;
		}
		.waitPreview {
			color: #4b83f7;
		}
		.inPreview {
			color: orange;
		}
		.passed {
			color: #50b173;
		}
		.rejected {
			color: #f74b4b;
		}
		::v-deep .el-date-editor.el-input {
			width: 150px;
		}
		::v-deep .el-date-editor .el-input__inner {
			width: 150px !important;
		}
		::v-deep .el-icon-arrow-left {
			margin-top: 0;
		}
		::v-deep .el-icon-arrow-right {
			margin-top: 0;
		}
	}
	::v-deep .delDialog {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 480px;
		height: 284px;
		margin-top: 0 !important;
	}

	::v-deep .el-dialog__header {
		padding: 15px 20px;
		border-bottom: 1px solid #f2f2f2;
	}
	::v-deep .el-dialog__body {
		padding: 60px 0;
		text-align: center;
	}
</style>
<style>
	.popper-panel-more-allapp {
		padding: 6px;
	}
</style>
